<template>
    <v-row align="center" justify="center" class="mar-top-100">
        <v-dialog
            v-model="zoomModal"
            scrollable
            max-width="1000px"
            style="z-index: 999;"
        >
            <v-card>
                <v-card-title class="d-flex justify-end">
                    <div class="close-icon" style="cursor: pointer;" @click="zoomModal = false">
                        X
                    </div>
                </v-card-title>

                <v-card-text style="height: 760px;" class="scrollbar" id="scrollbar">
                    <DealModalHeader
                        :company_id="company_id"
                        :stages="stages"
                        :investmentStage="investmentStage"
                        :fund_raising="fund_raising"
                    />

                    <div>
                        <b-card no-body>
                            <b-tabs card>
                                <b-tab title="Business" active @click="setSection('business')">
                                    <b-card-text v-if="section == 'business'">
                                        <Business
                                            :company_id="company_id"
                                            :type="type"
                                            :type_growth="type_growth"
                                            :type_size="type_size"
                                        />
                                    </b-card-text>
                                </b-tab>

                                <b-tab title="Product" @click="setSection('product')">
                                    <b-card-text v-if="section == 'product'">
                                        <Product :company_id="company_id" />
                                    </b-card-text>
                                </b-tab>

                                <b-tab title="Company" @click="setSection('company')">
                                    <b-card-text v-if="section == 'company'">
                                        <CompanyComponent :company_id="company_id" />
                                    </b-card-text>
                                </b-tab>

                                <b-tab title="Financials" @click="setSection('financials')">
                                    <b-card-text v-if="section == 'financials'">
                                        <Financials :company_id="company_id" />
                                    </b-card-text>
                                </b-tab>
                            </b-tabs>
                        </b-card>  
                    </div>
                </v-card-text>
                
                <v-divider></v-divider>
                <v-card-actions class="d-flex justify-content-center text-center" centerr>
                    <div>
                        <p class="m-0" style="color: #5ae6ff;">Add this new deal in my dealflow ?</p>
                        <div class="d-flex justify-content-center align-items-center text-center" style="gap: 15px">
                            <img
                                class="mt-n1 d-none"
                                alt="Ideasfundx dinied icon"
                                src="../../../assets/img/a-2.png"
                                height="60" 
                                width="56"
                            />
                            <div class="mt-2 mb-4">
                                <img
                                    alt="Add this deal in my deal flow"
                                    title="Add this deal in my deal flow"
                                    src="../../../assets/img/a-1.png"
                                    height="45"
                                    width="45"
                                    @click="saveDeal"
                                    style="cursor: pointer;"
                                    v-if="!add_deal_loader"
                                />
                                <div v-else class="spinner-border text-secondary mt-2" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-col cols="12" sm="10" md="9" lg="10">
            <v-row>
                <v-col cols="11" sm="11">
                    <p class="cyan--text text--darken-1 text-sm-left m-0" id="title">Find new opprtunities</p>
                    <div class="m-0">According to your investment theses, select 1-3 filters</div>
                </v-col>
            </v-row>
            <div class="mt-4">
                <div class="row">
                    <div class="col-12 col-md-4">
                        <v-checkbox
                            v-model="selectBusiness"
                            @change="selectAndUnselectBusiness()"
                        >
                            <template v-slot:label>
                                <span class="header-label">Business</span>
                            </template>
                        </v-checkbox>

                        <div class="mt-6">
                            <v-checkbox
                                v-model="business.industry"
                                label="Industry"
                            ></v-checkbox>

                            <v-checkbox
                                v-model="business.model"
                                label="Business Model Type"
                                class=""
                            ></v-checkbox>

                            <v-checkbox
                                v-model="business.location"
                                label="Market Location"
                                class=""
                            ></v-checkbox>
                            <v-checkbox
                                v-model="business.market_size"
                                label="Market Size"
                                class=""
                            ></v-checkbox>
                            <v-checkbox
                                v-model="business.market_growth"
                                label="Market Growth"
                                class=""
                            ></v-checkbox>
                            <v-checkbox
                                v-model="business.product"
                                label="Offer Type"
                                class=""
                            ></v-checkbox>
                            <v-checkbox
                                v-model="business.technology_focus"
                                label="Technology Focus"
                                class=""
                            ></v-checkbox>
                            <v-checkbox
                                v-model="business.rd"
                                label="R&D"
                                class=""
                            ></v-checkbox>
                            <v-checkbox
                                v-model="business.patent"
                                label="Patent"
                                class=""
                            ></v-checkbox>
                            <v-checkbox
                                v-model="business.revenue"
                                label="Minimum Monthly Recurring Revenue"
                                class=""
                            ></v-checkbox>
                        </div>
                    </div>

                    <div class="col-12 col-md-4">
                        <v-checkbox
                            v-model="selectCompanies"
                            @change="selectAndUnselectCompanies()"
                        >
                            <template v-slot:label>
                                <span class="header-label">Companies</span>
                            </template>
                        </v-checkbox>

                        <div class="mt-6">
                            <v-checkbox
                                v-model="company.company_HQ"
                                label="Company HQ Country"
                            ></v-checkbox>

                            <v-checkbox
                                v-model="company.incorprate_US"
                                label="Incorporate in US"
                            ></v-checkbox>

                            <v-checkbox
                                v-model="company.under_founders"
                                label="Underrepresented Founders"
                            ></v-checkbox>
                        </div>
                    </div>

                    <div class="col-12 col-md-4">
                        <v-checkbox
                            v-model="selectInvestment"
                            @change="selectAndUnselectInvestment()"
                        >
                            <template v-slot:label>
                                <span class="header-label">Investment</span>
                            </template>
                        </v-checkbox>
                        <div class="mt-5 ml-4">Investment Range</div>

                        <div class="mt-n4">
                            <div class="ml-4">
                                <v-checkbox
                                    v-model="investment.range_$100K_$500K"
                                    label="100K_499K"
                                ></v-checkbox>

                                <v-checkbox
                                    v-model="investment.range_$500K_$1500K"
                                    label="$500K-$1,499K"
                                ></v-checkbox>

                                <v-checkbox
                                    v-model="investment.range_$1500K_$3000K"
                                    label="$1,500K-$2,999K"
                                ></v-checkbox>

                                <v-checkbox
                                    v-model="investment.range_plus_$3000K"
                                    label="More than $3,000K"
                                ></v-checkbox>
                            </div>

                            <v-checkbox
                                v-model="investment.investment_stage"
                                label="Investment Stage"
                            ></v-checkbox>
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-center">
                    <div class="matchBtn mt-5" @click="getCompanies()">
                       {{ loader ? "Loading..." : "Matching" }}
                    </div>
                </div>
            </div>
            <div v-if="showTable">
                <p class="cyan--text text--darken-1 text-center" style="font-size: 22px;">List of new opportunities matching your search</p>
                <hr />
                <div class="table-responsive-wrapper">
                    <table class="table table-striped matching-table table-responsive">
                        <thead class="w-100">
                            <tr class="w-100">
                                <th>Industry Sector</th>
                                <th>HQ Country</th>
                                <th>Market type</th>
                                <th>Type of offer</th>
                                <th>Technology Focus</th>
                                <th>Investment round</th>
                                <th>Needs</th>
                            </tr>
                        </thead>
                        <tbody v-if="!loader">
                            <tr class="" v-for="company in companies" :key="company.id">
                                <td>{{ company.business.industry.join(', ') }}</td>
                                <td>{{ company.country }}</td>
                                <td>{{ company.business.model }}</td>
                                <td>{{ company.business_products && company.business_products.service_offer }}</td>
                                <td>{{ company.business_products && company.business_products.technology_focus ? 'Yes' : 'No' }}</td>
                                <td>{{ company.investment ? capitalizeFLetter(company.investment.stage) : '---' }}</td>
                                <td>{{ company.needs ? company.needs.needed.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '---' }}</td>
                                <td>
                                    <b-dropdown id="dropdown-1" text="More" class="w-100">
                                        <b-dropdown-item @click="openZoomModal(company.id), getInvestmentStage(company.id)">Zoom</b-dropdown-item>
                                        <b-dropdown-item>Status</b-dropdown-item>
                                    </b-dropdown>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="text-center" v-if="companies.length === 0 && !loader">
                    <img
                        alt="Ideasfundx logo"
                        src="../../../assets/img/folder.png"
                        class="mt-2"
                        height="70"
                        width="70"
                    />
                    <p>No matching companies found at the moment.</p>
                </div>

                <div class="text-center w-100" v-if="loader">
                    <div class="spinner-border text-secondary">
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>
            </div>
        </v-col>
    </v-row>
</template>

<script>
    import Company from '@/store/services/company/company.service.js'
    import DealModalHeader from './findDeal/DealModalHeader'
    import Business from "./findDeal/Business.vue"
    import Product from './findDeal/Product.vue';
    import CompanyComponent from './findDeal/CompanyComponent';
    import Financials from './findDeal/Financials.vue';
    import FinanceService from "@/store/services/finance.service";
    import Var from "@/store/services/var";
    import NeedService from "@/store/services/need.service";
    import BusinessService from "@/store/services/business.service";

    export default {
        components: {
            DealModalHeader,
            Business,
            Product,
            CompanyComponent,
            Financials
        },
        data() {
            return {
                company_id: null,
                selectBusiness: false,
                selectCompanies: false,
                selectInvestment: false,
                business: {
                    industry: false,
                    model: false,
                    location: false,
                    market_size: false,
                    market_growth: false,
                    product: false,
                    technology_focus: false,
                    technology: false,
                    rd: false,
                    patent: false,
                    revenue: false
                },
                company: {
                    company_HQ: false,
                    incorprate_US: false,
                    under_founders: false
                },
                investment: {
                    range: false,
                    investment_stage: false,
                    range_$100K_$500K: false,
                    range_$500K_$1500K: false,
                    range_$1500K_$3000K: false,
                    range_plus_$3000K: false,
                },
                companies: [],
                loader: false,
                add_deal_loader: false,
                zoomModal: false,
                showTable: false,
                section: 'business',
                investmentStage: {},
                fund_raising: null,
                stages: [],

                type: { 
                    industry: [], 
                    location: []
                },
                type_growth: null,
                type_size: null,
            }
        },

        methods: {
            setSection(section) {
                this.section = section;
            },

            selectAndUnselectBusiness () {
                this.business = {
                    industry: this.selectBusiness,
                    model: this.selectBusiness,
                    location: this.selectBusiness,
                    market_size: this.selectBusiness,
                    market_growth: this.selectBusiness,
                    product: this.selectBusiness,
                    technology_focus: this.selectBusiness,
                    technology: false,
                    rd: this.selectBusiness,
                    patent: this.selectBusiness,
                    revenue: this.selectBusiness
                }
            },

            selectAndUnselectCompanies () {
                this.company = {
                    company_HQ: this.selectCompanies,
                    incorprate_US: this.selectCompanies,
                    under_founders: this.selectCompanies
                }
            },

            selectAndUnselectInvestment () {
                this.investment = {
                    range: this.selectInvestment,
                    investment_stage: this.selectInvestment,
                    range_$100K_$500K: this.selectInvestment,
                    range_$500K_$1500K: this.selectInvestment,
                    range_$1500K_$3000K: this.selectInvestment,
                    range_plus_$3000K: this.selectInvestment
                }
            },

            getCompanies () {
                this.showTable = true;
                this.loader = true;
                this.companies = [];
                let data = {
                    business: this.business,
                    company: this.company,
                    investment: this.investment
                }

                Company.getMatchiesCompanie(data).then(res => {
                    if (res.status == 200) {
                        this.companies = res.data;
                    }
                    this.loader = false;
                }).catch(() => {
                    this.loader = false;
                })
            },

            openZoomModal (id) {
                this.company_id = id;
                this.zoomModal = true;
            },

            saveDeal () {
                this.add_deal_loader = true;
                let data = {
                    company_id: this.company_id,
                    deal_status: 'New'
                }

                Company.saveDeal(data).then(res => {
                    if (res.status == 201) {
                        this.$toast.open({
                            message: `
                                <div style="display: flex; align-items: center; justify-content: space-between;">
                                    <span class="redirect-to-followup">${ res.data.message } <span onclick="this.$store.commit("UPDATE_PAGE", 'followUp')" class="link-followup" style="cursor: pointer;">go to Follow Up</span></span>
                                    <span
                                        class="toast-close-btn px-3 py-2"
                                        style="cursor: pointer; margin-top: -10px; margin-left: 10px; color: gray;" 
                                        onclick="this.parentElement.parentElement.parentElement.style.display='none';">
                                        X
                                    </span>
                                </div>`,
                            type: 'success',
                            position: 'top-right',
                            duration: 0,
                            onClick: (event) => {
                                if (event.target.classList.contains('toast-close-btn')) {
                                    return;
                                }
                                else {
                                    this.$store.commit("UPDATE_PAGE", 'followUp');
                                }
                            }
                        });
                        this.zoomModal = false;
                        this.companies = this.companies.filter(company => company.id !== res.data.dealflow.company_id)
                        // this.$store.commit("UPDATE_PAGE", 'followUp');
                    }
                    this.add_deal_loader = false;
                }).catch((error) => {
                    this.add_deal_loader = false;
                    this.$toast.open({
                        message: error.response.data.message || "Something went wrong",
                        type: 'error',
                        position: 'top-right',
                        duration: 3000
                    });
                })
            },

            capitalizeFLetter(string) {
                let value = string?.replace(/_/g, " "); // Replace underscores with spaces
                let str = value?.toLowerCase() || '';   // Convert the entire string to lowercase
                return str.replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize the first letter of each word
            },

            getInvestmentStage (company_id) {
                Var.getStages().then((res) => { this.stages = Object.values(res.data); })

                FinanceService.getInvestment(company_id).then((res) => {
                    this.investmentStage = res.data;

                    if (this.investmentStage.stage == 'seed_stage') { this.investmentStage.stage = 'Grants, Friends and Family Money (F&F$), Angel, private equity funds, Seed Capital - $25,000 to $1 million' }
                    else if (this.investmentStage.stage == 'series_a') { this.investmentStage.stage = 'Early-stage Series A funding is in the $1 million to $5 million range.' }
                    else if (this.investmentStage.stage == 'series_b') { this.investmentStage.stage = 'Early-stage Series B funding is in the $5 million to $10 million range.' }
                    else if (this.investmentStage.stage == 'later_stage') { this.investmentStage.stage = 'Series C and following rounds (expansion Stage, Mezzanine (bridge)) - (+$10 million)' }
                });

                NeedService.getFund(company_id).then((res) => { 
                    let fund = res.data;
                    this.fund_raising = fund.raising.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                });

                BusinessService.getType(this.company_id).then((res) => {
                    this.type = res.data;
                    this.type_size = res.data.size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    this.type_growth = res.data.growth.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                })
            },
        }
    }
</script>

<style>
    .header-find {
        margin-bottom: 4px;
        display: inline-block;
        align-self: flex-start;
        overflow-wrap: break-word;
        font-weight: 700;
        font-size: 20px;
        line-height: 1.4;
        color: #00A8C2;
    }

    .matchBtn {
        border-radius: 10px;
        background: linear-gradient(180deg, #00A8C2, #018E6C);
        margin: 0 27px 35px 27px;
        padding: 18px 0;
        width: 165px;
        text-align: center;
        box-sizing: border-box;
        color: #fff;
        cursor: pointer;
    }
    .matchBtn:hover{background:linear-gradient(90deg,#24c091,#00a8c3);}
    .custom-label {
        color: #ff0000 !important; /* Change #ff0000 to your desired color */
    }
    .matching-table tr th {
        background: #f6f6f6;
        border: none !important;
    }
    .matching-table tr th:nth-child(odd) {
        background: #00a8c3;
    }
    .matching-table td:nth-child(odd) {
        background-color: #def5f9;
    }
    .btn.dropdown-toggle {
        background: #2c7bb2 !important;
        border: none;
    }

    /* ScroolBar class="v-dialog v-dialog--active" */
    .v-dialog::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px #f7f7f9;
        background-color: #fff;
    }

    .v-dialog::-webkit-scrollbar {
        width: 10px;
        background-color: #f5f5f5;
    }

    .v-dialog::-webkit-scrollbar-thumb {
        background-color: #dfdfdf;
    }

    .header-label {
        color: #00a8c3;
        font-weight: 700;
    }
    .text-black {
        color: #000;
    }
    .bottom-btns {
        position: fixed !important;
        bottom: 70px;
    }
    .text-bold input, .v-select__selection--comma {
      color: #000 !important;
      font-weight: 800 !important;
    }
    .nav-link {
        color: #000 !important;
    }
    .nav-link.active {
        color: #00a8c3 !important;
        font-weight: 800;
    }
    .close-icon:hover {
        color: #00A8C2;
    }
    .link-follup {
        color: #000000 !important;
        cursor: pointer;
        font-weight: 500;
        font-size: 14px;
    }
    .link-follup:hover {
        color: #242424 !important;
    }
    .redirect-to-followup {
        cursor: pointer;
        font-weight: 500;
        font-size: 14px;
    }
</style>